<template>
    <div class="sale">
        <img src="http://test-data.hkautoexpo.com/banner/sale.webp">
    </div>
</template>
<script setup>

</script>

<style lang="scss" scoped>
    .sale {
        img {
            width: 100%;
        }
    }   
</style>    